import { PropsWithChildren } from 'react';

export const Well = ({ children }: PropsWithChildren<unknown>) => (
  <section className="space-y-6 bg-white p-3 sm:rounded-3xl sm:border sm:border-ebony-clay-100 sm:p-6 sm:shadow-sm">
    {children}
  </section>
);
